<div mat-dialog-title>
  <span>{{ 'GENERAL.ERROR' | translate }}</span>
</div>

<mat-dialog-content [ngStyle]="{width: dialogWidth}" class="confirm-delete-content">
  <p>
    {{ message | translate }}
    <span *ngIf="additionalMessage">{{ additionalMessage }}</span>
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-primary-button color="warn" (click)="ok()">
    {{ 'POPUPS.OK' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
